<template>
    <v-row>
        <v-col v-for="detail in details[0]" :key="detail.id" cols="12">
            <v-card flat align="center" class="card dt-border">
                <v-row align="center">
                    <v-col cols="12" md="3">
                        <p class="mb-0">{{ `${detail.admin.profile.firstname}&nbsp;${detail.admin.profile.lastname}` }} <sup class="info white--text pa-1 rounded">{{detail.module}}</sup></p>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-chip :title="detail.details" color="accent">
                            {{detail.action}}
                        </v-chip>
                    </v-col>
                    <v-col cols="12" md="3">
                        <p class="mb-0">{{formatDate(detail.actionTime)}} <span class="primary--text">@</span> {{formatTime(detail.actionTime)}}</p>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-chip :title="detail.details" :color="status(detail.status)">
                            {{detail.status}}
                        </v-chip>
                    </v-col>
                    <v-col cols="12" md="1">
                        <small class="mb-0 table-link" @click="viewlog(detail)">Inspect</small>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
        <audit-modal :detail="detail" @closeModal=" dialog = false" :dialog="dialog" />
    </v-row>
</template>

<script>
import AuditModal from './audit-modal.vue'
import { parseTimestamp } from '@/utils/dates';
export default {
    props:{
        details:{
            type:Array
        }
    },
    data:() =>({
        dialog : false,
        detail : {}
    }),
    components:{
        AuditModal
    },
    computed:{
        
    },
    methods:{
        formatDate(date){
            let d = new Date(date)
            let reModelDate = d.toLocaleString(["en-Us"], {
                month: "short",
                day: "2-digit",
                year: "numeric",
            });
            return reModelDate;
        },
        formatTime(time){
            return parseTimestamp(new Date(time), 'HH:mm');
        },
         status(color){
            let data;
            if(color == "successful"){
                data = "success"
            }
            else if(color == "failed"){
                data = "error"
            }
            return data
        },
        viewlog(detail){
            this.detail = detail;
            this.dialog = true;
        }
    }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
small{
    color: #656565;
    font-weight: 600;
    text-decoration: underline;
}
</style>